import { useState, useEffect } from "react";

// Variables to manage the timer centrally
let intervalId = null;
let intervalRefCounter = 0;

// const circulatingSupply = 6426120416.616;
// const totalSupply = 94938206930.825;

const useMarketData = () => {
  const [marketData, setMarketData] = useState({
    buyOrders: null,
    sellOrders: null,
    midMarketPrice: null,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const urls = [
          "https://api.0lswap.com/orders/public/buyOrders?market=OLUSDT",
          "https://api.0lswap.com/orders/public/sellOrders?market=OLUSDT",
        ];
        const [buyOrdersResponse, sellOrdersResponse] = await Promise.all(
          urls.map((url) => fetch(url))
        );
        const [buyOrders, sellOrders] = await Promise.all([
          buyOrdersResponse.json(),
          sellOrdersResponse.json(),
        ]);

        const midMarketPrice = calculateMidMarketPrice(buyOrders, sellOrders);

        setMarketData({
          buyOrders: buyOrders,
          sellOrders: sellOrders,
          midMarketPrice: midMarketPrice,
        });
      } catch (error) {
        console.error("Failed to fetch market data:", error);
      }
    };

    // Increment the reference counter and create the interval if necessary
    if (intervalRefCounter === 0) {
      intervalId = setInterval(fetchData, 30000);
    }
    intervalRefCounter += 1;

    // Initial immediate call
    fetchData();

    // Cleanup function
    return () => {
      intervalRefCounter -= 1;
      if (intervalRefCounter === 0) {
        clearInterval(intervalId);
        intervalId = null;
      }
    };
  }, []);

  return marketData;
};

const calculateMidMarketPrice = (bids, asks) => {
  if (!bids.length || !asks.length) {
    return null; // Return null if there is insufficient data
  }
  const highestBid = Math.max(...bids.map((bid) => bid.price));
  const lowestAsk = Math.min(...asks.map((ask) => ask.price));
  return (highestBid + lowestAsk) / 2;
};

export default useMarketData;
